// // src/pages/Dashboard/Dashboard.js (main file)
// import PropTypes from "prop-types"
// import React, { useState } from "react"
// import { Container, Row, Col } from "reactstrap"

// // Components
// import DashboardCards from "./DashboardCards"
// import DashboardSection from "./DashboardSection"
// import Earnings from "./Earnings"
// import TransactionTable from "./TransactionTable"

// // Breadcrumb
// import Breadcrumbs from "../../components/Common/Breadcrumb"

// // i18n
// import { withTranslation } from "react-i18next"

// const Dashboard = props => {
//   // Filters state – yahan se control hoga
//   const [filters, setFilters] = useState({
//     startDate: null,
//     endDate: null,
//     mobileNumbers: [], // array of strings
//   })

//   // Reset filters
//   const handleReset = () => {
//     setFilters({
//       startDate: null,
//       endDate: null,
//       mobileNumbers: [],
//     })
//   }

//   // Apply filters (DashboardSection se call hoga)
//   const handleApply = newFilters => {
//     setFilters(newFilters)
//   }

//   document.title = "Dashboard | Your App Name"

//   return (
//     <React.Fragment>
//       <div className="page-content">
//         <Container fluid>
//           {/* Breadcrumb */}
//           <Breadcrumbs
//             title={props.t("Dashboards")}
//             breadcrumbItem={props.t("Dashboard")}
//           />

//           {/* Filters Section */}
//           <Row className="mb-3">
//             <Col xl="12">
//               <DashboardSection
//                 onApply={handleApply}
//                 onReset={handleReset}
//                 currentFilters={filters} // optional: current values dikhane ke liye
//               />
//             </Col>
//           </Row>

//           {/* Stats Cards */}
//           <div className="mb-3">
//             <DashboardCards filters={filters} />
//           </div>

//           {/* Analysis Chart (Earnings) – filters pass kar do */}
//           <Row className="mb-3">
//             <Col xl="12">
//               <Earnings filters={filters} dataColors='["--bs-primary"]' />
//             </Col>
//           </Row>

//           {/* Transaction Table */}
//           <Row className="mb-3">
//             <Col xl="12">
//               <TransactionTable filters={filters} />
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </React.Fragment>
//   )
// }

// Dashboard.propTypes = {
//   t: PropTypes.any,
// }

// export default withTranslation()(Dashboard)

// src/pages/Dashboard/Dashboard.js
import PropTypes from "prop-types"
import React, { useState, useRef } from "react"
import { Container, Row, Col } from "reactstrap"

// Components
import DashboardCards from "./DashboardCards"
import DashboardSection from "./DashboardSection"
import Earnings from "./Earnings"
import TransactionTable from "./TransactionTable"

// Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

// i18n
import { withTranslation } from "react-i18next"

const Dashboard = props => {
  // Filters state – yahan se control hoga
  const [filters, setFilters] = useState({
    startDate: null,
    endDate: null,
    mobileNumbers: [], // array of strings
  })

  // Shared cache for TransactionTable (pagination caching ke liye)
  const sharedCache = useRef(new Map())

  // Reset filters
  const handleReset = () => {
    setFilters({
      startDate: null,
      endDate: null,
      mobileNumbers: [],
    })
  }

  // Apply filters (DashboardSection se call hoga)
  const handleApply = newFilters => {
    setFilters(newFilters)
  }

  document.title = "Dashboard | Your App Name"

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumb */}
          <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          />

          {/* Filters Section */}
          <Row className="mb-3">
            <Col xl="12">
              <DashboardSection
                onApply={handleApply}
                onReset={handleReset}
                currentFilters={filters} // optional: current values dikhane ke liye
              />
            </Col>
          </Row>

          {/* Stats Cards */}
          <div className="mb-3">
            <DashboardCards filters={filters} />
          </div>

          {/* Analysis Chart (Earnings) – filters pass kar do */}
          <Row className="mb-3">
            <Col xl="12">
              <Earnings filters={filters} dataColors='["--bs-primary"]' />
            </Col>
          </Row>

          {/* Transaction Table – ab sharedCache aur tabKey pass kar rahe hain */}
          <Row className="mb-3">
            <Col xl="12">
              <TransactionTable
                filters={filters}
                tabKey="dashboard-transactions" // unique key for this table's cache
                sharedCache={sharedCache}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Dashboard)
